const subscribeToComments = function() {
    let button;
  
    const _init = function() {
      button = document.getElementById('ecnDisplayForm');
      button.addEventListener('click', _toggleContent, false);
    };
  
    const _toggleContent = function() {
      button.parentNode.classList.toggle('open');
    };
  
    return {
      init: _init
    }
  }();
  
  if (document.getElementById('ecnDisplayForm')) {
    subscribeToComments.init();
  }